export const order = 4;
export const routes = {
  path: "/",
  name: "configurationLayout",
  component: () => import("@/views/layout"),
  meta: {
    title: "参数配置",
    guard: {
      role: ["Admin"],
      permission: ["upms:configuration"],
    },
  },
  children: [
    {
      path: "configurationPage",
      name: "configurationPage",
      meta: {
        title: "参数配置",
        guard: {
          role: ["Admin"],
          permission: ["upms:configuration:configurationPage"],
        },
      },
      component: () => import("@/views/configuration")
    }
  ]
};
export const perms = {
  configurationPage: [
    {
      title: "新增",
      permission: "upms:configuration:configurationPage:add",
    },
    {
      title: "设置学习形式",
      permission: "upms:configuration:configurationPage:setting:xxxs",
    },
    {
      title: "设置总学时要求",
      permission: "upms:configuration:configurationPage:setting:xsyq",
    },
    {
      title: "编辑",
      permission: "upms:configuration:configurationPage:xxxsedit"
    },
    {
      title: "删除",
      permission: "upms:configuration:configurationPage:xxxsdel"
    },
    {
      title: "编辑",
      permission: "upms:configuration:configurationPage:xsyqedit"
    },
    {
      title: "删除",
      permission: "upms:configuration:configurationPage:xsyqdel"
    },
    {
      title: "编辑",
      permission: "upms:configuration:configurationPage:edit",
    },
    {
      title: "选择流程",
      permission: "upms:configuration:configurationPage:flow"
    },
    {
      title: "删除",
      permission: "upms:configuration:configurationPage:del"
    }
  ]
};
